// extracted by mini-css-extract-plugin
export var bubble = "_31-0";
export var container = "_31-3";
export var contrastBorder = "_31-4";
export var greyOut = "_31-2";
export var initialsWrapper = "_31-1";
export var large = "_31-9";
export var medium = "_31-8";
export var mediumSmall = "_31-7";
export var mediumSmallMedium = "_31-c";
export var micro = "_31-5";
export var small = "_31-6";
export var tiny = "_31-b";
export var xTiny = "_31-a";